import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const DateInput = styled.input`
  padding: 3px;
  font-size: 15px;
  border: 1px solid rgb(157, 163, 181);
  border-radius: 8px;
  outline: none;
  cursor: pointer;
  transition: border-color 0.3s;

  &:hover,
  &:focus {
    border-color: #007bff;
  }
`;

const DatePickerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: 7px;
`;

const getTodayDate = () => new Date().toISOString().split("T")[0];

const DatePicker = ({ initialDate, onDateChange }) => {
  const [selectedDate, setSelectedDate] = useState(initialDate || getTodayDate());

  useEffect(() => {
    setSelectedDate(initialDate || getTodayDate());
  }, [initialDate]);

  const handleChange = (e) => {
    const newDate = e.target.value;
    setSelectedDate(newDate);
    if (onDateChange) {
      onDateChange(newDate);
    }
  };

  return (
    <DatePickerContainer>
      <DateInput type="date" value={selectedDate} onChange={handleChange} />
    </DatePickerContainer>
  );
};

// 🔹 Пропсы с типизацией
DatePicker.propTypes = {
  initialDate: PropTypes.string, // Дата в формате 'YYYY-MM-DD'
  onDateChange: PropTypes.func,  // Функция-коллбэк при изменении даты
};

// 🔹 Значения по умолчанию
DatePicker.defaultProps = {
  initialDate: getTodayDate(),
  onDateChange: () => {},
};

export default DatePicker;